const POPUP_ELEMENT = {
    container: '.js-m-popup',
    popupLink: '.js-m-popup-link',
    popupCloseButton: '.js-close-popup',
};

const STATE = {
    show: 'is-show',
    disableScroll: 'is-disabled-scroll'
};

/**
 * Закртие модального окна
 * @param popupContainer {HTMLElement}
 */
function closePopup(popupContainer) {
    popupContainer.classList.remove(STATE.show);
    document.body.classList.remove(STATE.disableScroll);
}

/**
 * Открытие модального окна
 * @param popupContainer {HTMLElement}
 */
function openPopup(popupContainer) {
    popupContainer.classList.add(STATE.show);
    document.body.classList.add(STATE.disableScroll);
}

/**
 * Закрытие попапа с помощью кнопок
 * @param closeButtons {NodeList} - кнопки закрытия
 * @param popupContainer {HTMLElement} - попап
 */
function closePopupByButtons(closeButtons, popupContainer) {
    closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            closePopup(popupContainer);
        });
    });
}

/**
 * Закрытие модального окна при клике на серую часть popup
 * @param popupContainer {HTMLElement} - попап
 */
function closePopupOutsideClick(popupContainer) {
    document.body.addEventListener('click', (event) => {
        if (popupContainer === event.target) {
            closePopup(popupContainer);
        }
    });
}

/**
 * Откроет попап и запустить листнеры для его заркытия
 * @param popupContainer {HTMLElement}
 */
function initPopup(popupContainer) {
    const closeButtons = popupContainer.querySelectorAll(POPUP_ELEMENT.popupCloseButton);

    openPopup(popupContainer);
    closePopupByButtons(closeButtons, popupContainer);
    closePopupOutsideClick(popupContainer);
}

/**
 * откртытие попапа по прямой ссылки с hash
 * @returns {boolean}
 */
function openPopupFromHash() {
    const currentUrlHash = window.location.hash;

    if (!currentUrlHash) return false;

    const popupContainer = document.querySelector(currentUrlHash);

    if (!popupContainer) {
        console.error(`Разметка с попапом ${currentUrlHash} не найдена`);
        return false;
    }

    initPopup(popupContainer);
}

function popup() {
    const openLink = document.querySelectorAll(POPUP_ELEMENT.popupLink);

    openPopupFromHash();

    openLink.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const id = link.getAttribute('href');
            const popupContainer = document.querySelector(id);

            if (!popupContainer) {
                console.error(`Разметка с попапом ${id} не найдена`);
                return false;
            }

            initPopup(popupContainer);
        });
    });
}

export default popup;
